function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { HEADER_SEARCH_RESULTS, HEADER_PRODUCT_LISTING } from 'swag-client-common//utils/constants';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import SwagLogo from 'swag-client-common/components/ui/swag-logo';
import SwagPhone from 'swag-client-common/components/ui/swag-phone';
import { Color } from '../ui/swag-logo/swag-logo';
import { ShowErrorPopup } from '../../../customer/components/popups/show-error-popup';
import { OffersDropdown } from './components';
import { SuperSpeedButton } from './components/super-speed-button';
import classes from './header.scss';
import appearAnimationClasses from './appear.anim.scss';
export class HeaderComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isAllSwagHovered: false
    });
    _defineProperty(this, "handleIsAllSwagHoveredChange", isAllSwagHovered => {
      this.setState({
        isAllSwagHovered: Boolean(isAllSwagHovered)
      });
    });
  }
  render() {
    const isMobileMode = isMobile();
    const {
      isViolet,
      isLimitedEdition,
      sticky,
      isCategoriesSticky,
      isStuck,
      headerLink,
      headerLogoContent,
      promoPage = false,
      showCategories = true,
      SwagAccount,
      ProductListingPanel,
      SearchProducts,
      useHardLinks,
      isPageBlockedImmediately = false,
      isBoxButtonShown = true,
      isFilterOpened,
      routeNavigationConfirmation,
      SearchResultsPageProductListingPanel,
      FiltersRow,
      headerType,
      showSuperSpeedButton,
      isPhoneShown = true
    } = this.props;
    const {
      isAllSwagHovered
    } = this.state;
    const currentRoute = 'collections';
    const isSearchResultsCurrentRoute = headerType === HEADER_SEARCH_RESULTS;
    const isProductListingCurrentRoute = headerType === HEADER_PRODUCT_LISTING;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.header, {
        [classes.fixedHeader]: isMobileMode && isPageBlockedImmediately,
        [classes.stuck]: isStuck
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.promotional, {
        [classes.violet]: isViolet,
        [classes.black]: isLimitedEdition,
        [classes.sticky]: sticky
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.combinedBlock
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.logoWrapper, {
        [classes.showLogo]: !showCategories || promoPage
      })
    }, /*#__PURE__*/React.createElement(SwagLogo, {
      sticky: sticky,
      link: headerLink,
      logoClassName: classes.logo,
      partners: headerLogoContent,
      isHardLink: useHardLinks,
      color: isLimitedEdition ? Color.limitedEdition : Color.white
    })), SwagPhone && isPhoneShown && /*#__PURE__*/React.createElement(SwagPhone, null), (showCategories || promoPage) && /*#__PURE__*/React.createElement(OffersDropdown, null)), /*#__PURE__*/React.createElement(SwagAccount, {
      isViolet: isViolet,
      isLimitedEdition: isLimitedEdition,
      SearchProducts: SearchProducts,
      addBrowseProduct: !showCategories,
      useHardLinks: useHardLinks,
      isBoxButtonShown: isBoxButtonShown,
      routeNavigationConfirmation: routeNavigationConfirmation
    })), /*#__PURE__*/React.createElement(CSSTransition, {
      in: showCategories && isCategoriesSticky,
      timeout: 255,
      classNames: appearAnimationClasses,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classNames(classes.main, {
        [classes.sticky]: sticky,
        [classes.openedFilterMain]: isFilterOpened,
        [classes.negativeBottomMargin]: isAllSwagHovered && !isFilterOpened && (isProductListingCurrentRoute || isSearchResultsCurrentRoute)
      })
    }, promoPage ? /*#__PURE__*/React.createElement("div", {
      className: classes.logoPlug
    }) : /*#__PURE__*/React.createElement(SwagLogo, {
      link: headerLink,
      logoClassName: classNames(classes.logo, classes.dynamicLogo),
      partners: headerLogoContent,
      isHardLink: useHardLinks,
      color: Color.black
    }), ProductListingPanel && !isSearchResultsCurrentRoute && /*#__PURE__*/React.createElement(ProductListingPanel, {
      changeIsAllSwagHovered: this.handleIsAllSwagHoveredChange,
      currentRoute: currentRoute,
      isViolet: isViolet,
      sticky: sticky
    }), SearchResultsPageProductListingPanel && isSearchResultsCurrentRoute && /*#__PURE__*/React.createElement(SearchResultsPageProductListingPanel, {
      changeIsAllSwagHovered: this.handleIsAllSwagHoveredChange,
      currentRoute: currentRoute,
      isViolet: isViolet,
      sticky: sticky
    }), showSuperSpeedButton ? /*#__PURE__*/React.createElement(SuperSpeedButton, null) : /*#__PURE__*/React.createElement("div", {
      className: classes.blankDiv
    })))), isProductListingCurrentRoute || isSearchResultsCurrentRoute ? /*#__PURE__*/React.createElement(FiltersRow, {
      isAllSwagHovered: isAllSwagHovered,
      isCategoriesSticky: isCategoriesSticky
    }) : null, /*#__PURE__*/React.createElement(ShowErrorPopup, null));
  }
}